import { Tag, type TagProps, api } from 'common';

const TagPropsByState: Record<api.FlowDefinition.FlowDefinition['state'], TagProps> = {
  [api.FlowDefinition.FlowDefinitionState.Draft]: { color: 'primary' },
  [api.FlowDefinition.FlowDefinitionState.Review]: { color: 'primary' },
  [api.FlowDefinition.FlowDefinitionState.Published]: { color: 'success' },
  [api.FlowDefinition.FlowDefinitionState.Superseded]: { color: 'warning' },
  [api.FlowDefinition.FlowDefinitionState.SoftDeleted]: { color: 'error' },
};

interface FlowDefinitionStateTagProps {
  state: api.FlowDefinition.FlowDefinition['state'];
}

export function FlowDefinitionStateTag(props: FlowDefinitionStateTagProps) {
  const { state } = props;
  return (
    <Tag {...TagPropsByState[state]}>{api.FlowDefinition.FlowDefinitionStateProps[state].name}</Tag>
  );
}
